import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const stats = [
  { value: 73, suffix: "+", label: "Satisfied Clients" },
  { value: 300, suffix: "+", label: "Completed Orders" },
  { value: 80, suffix: "+", label: "Brands Joined" },
  { value: 5, suffix: "+", label: "Marketing Experts" },
];

const Counter = ({ target, suffix, label }: { target: number; suffix: string; label: string }) => {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 1500;
          const step = target / (duration / 16);
          let current = 0;
          const timer = setInterval(() => {
            current += step;
            if (current >= target) {
              setCount(target);
              clearInterval(timer);
            } else {
              setCount(Math.floor(current));
            }
          }, 16);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <div ref={ref} className="text-center bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-5 md:p-8 hover:bg-white/20 transition-colors">
      <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-extrabold text-primary-foreground mb-1 md:mb-2">
        {count}{suffix}
      </p>
      <p className="text-xs md:text-sm text-primary-foreground/70 font-medium">{label}</p>
    </div>
  );
};

const AchievementsSection = () => {
  return (
    <section className="py-12 md:py-20 gradient-hero relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_50%,hsl(var(--secondary)/0.3),transparent_70%)]" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-4">
          <span className="inline-block px-5 py-2 rounded-full bg-white/20 text-primary-foreground text-xs font-semibold tracking-widest uppercase mb-4">Achievement</span>
        </div>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-primary-foreground text-center mb-4">
          Our Achievements in Digital Growth
        </h2>
        <p className="text-primary-foreground/70 max-w-2xl mx-auto text-center mb-6 text-sm md:text-base px-2">
          With over 3 years of industry experience, we've empowered businesses worldwide through measurable success.
        </p>
        <div className="text-center mb-8 md:mb-12">
          <Link
            to="/achievements"
            className="inline-flex px-6 py-3 rounded-full bg-white text-primary font-display font-semibold text-sm hover:bg-white/90 transition-colors"
          >
            View All Achievements
          </Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 max-w-4xl mx-auto">
          {stats.map((s) => (
            <Counter key={s.label} target={s.value} suffix={s.suffix} label={s.label} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
